import { render, staticRenderFns } from "./CannabisDetails.vue?vue&type=template&id=baa42c3e&scoped=true&"
import script from "./CannabisDetails.vue?vue&type=script&lang=js&"
export * from "./CannabisDetails.vue?vue&type=script&lang=js&"
import style0 from "./CannabisDetails.vue?vue&type=style&index=0&id=baa42c3e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa42c3e",
  null
  
)

export default component.exports